import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";
import { ICustomer } from "../../types";

interface CustomerResponse {
  data: {
    users: ICustomer[];
    totalCount: number;
  };
}

interface CustomerDetailsResponse {
  data: ICustomer;
}

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: customBaseQuery,
  tagTypes:['details','list'],
  endpoints: (builder) => ({
    getCustomerList: builder.query<
      CustomerResponse,
      { page: number; search?: string }
    >({
      query: ({ page, search }) => {
        let url = `/user/list?pageNumber=${page}&pageSize=10`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return {
          url,
          method: "GET",
        };
      },
      providesTags:['list']
    }),
    getCustomerDetails: builder.query<CustomerDetailsResponse, number>({
      query: (userId) => ({
        url: `/user/details?userId=${userId}`,
        method: "GET",
      }),
        providesTags:['list']
    }),
    updateUserStatus: builder.mutation<
      void,
      { userId: number; status: number }
    >({
      query: (body) => ({
        url: "/user/status",
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")?.toString() || "",
        },
      }),
      invalidatesTags:['list','details']
    }),
    addCustomer: builder.mutation<void, FormData>({
      query: (body) => {
        const formData = new FormData();
        Object.entries(body).forEach(([key, value]) => {
          formData.append(key, value as string);
        });
        return {
          url: "/user",
        method: "POST",
        body: formData,
      
        };
      },
      invalidatesTags:['list','details']
    }),
    updateCustomer: builder.mutation<void, FormData>({
      query: (body) => {
        const formData = new FormData();
        Object.entries(body).forEach(([key, value]) => {
          formData.append(key, value as string);
        });
        return {
          url: "/user"  ,
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags:['list','details']
    }),
    addTradeReference: builder.mutation<void, FormData>({
      query: (body) => {
        
        return {
          url: "/user/trade-reference",
          method: "POST",
          body: body,
        };
      },
      invalidatesTags:['list','details']
    }),
    updateTradeReference: builder.mutation<void, FormData>({
      query: (body) => {
        return {
          url: "/user/trade-reference",
          method: "PUT",
          body: body,
        };
      },
      invalidatesTags:['list','details']
    }),
  }),
});

export const {
  useGetCustomerListQuery,
  useGetCustomerDetailsQuery,
  useUpdateUserStatusMutation,
  useAddCustomerMutation,
  useUpdateCustomerMutation,
  useAddTradeReferenceMutation,
  useUpdateTradeReferenceMutation,
  } = customerApi;
